var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLinkSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03253 0.515625C7.03253 0.801367 7.26245 1.03125 7.54825 1.03125H9.74224L4.94813 5.82227C4.74614 6.02422 4.74614 6.35078 4.94813 6.55059C5.15013 6.75039 5.47675 6.75254 5.6766 6.55059L10.4685 1.75957V3.95312C10.4685 4.23887 10.6985 4.46875 10.9843 4.46875C11.2701 4.46875 11.5 4.23887 11.5 3.95312V0.515625C11.5 0.229883 11.2701 0 10.9843 0H7.54825C7.26245 0 7.03253 0.229883 7.03253 0.515625ZM2.04718 0.6875C1.19193 0.6875 0.5 1.3793 0.5 2.23438V9.45312C0.5 10.3082 1.19193 11 2.04718 11H9.26734C10.1226 11 10.8145 10.3082 10.8145 9.45312V6.70312C10.8145 6.41738 10.5846 6.1875 10.2988 6.1875C10.013 6.1875 9.78306 6.41738 9.78306 6.70312V9.45312C9.78306 9.73887 9.55313 9.96875 9.26734 9.96875H2.04718C1.76138 9.96875 1.53145 9.73887 1.53145 9.45312V2.23438C1.53145 1.94863 1.76138 1.71875 2.04718 1.71875H4.79771C5.08351 1.71875 5.31344 1.48887 5.31344 1.20312C5.31344 0.917383 5.08351 0.6875 4.79771 0.6875H2.04718Z",
    fill: "#5E06B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkSecondary);
export default __webpack_public_path__ + "static/media/external-link-secondary.dfb13a0aa35c62388d74f094d4c369b6.svg";
export { ForwardRef as ReactComponent };